import { z } from 'zod';

export const orderNumberSearchSchema = z
  .object({
    orderNumber: z.string().optional(),
  })
  .refine((data) => !data.orderNumber || /^\d{8}-\d{4}-\d{8}$/.test(data.orderNumber));
